import { mutatorAction, mutator } from 'satcheljs';
import getListViewState from '../selectors/getListViewState';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { onModuleClick } from 'owa-workloads';
import { Module } from 'owa-workloads-module';

export const updateStartAndEndIndicesInVLVMutator: (start: number, end: number) => void =
    mutatorAction('updateStartAndEndIndicesInVLVMutator', (start: number, end: number): void => {
        const listViewState = getListViewState();

        // [Not needed for Virtuoso] Subtracting both of these by 1 to account for the pre-rows component which takes index 0 in the VLV.
        // We want these indices to match the indices of the rows in the tableView.rowKeys.
        if (isGlobalFeatureEnabled('tri-virtuoso')) {
            listViewState.startIndexVLV = start;
            listViewState.endIndexVLV = end;
        } else {
            listViewState.startIndexVLV = start - 1;
            listViewState.endIndexVLV = end - 1;
        }
    });

// When the selected module changes away from Mail (and the component unmounts), reset the start
// and end indices in the listViewState as nothing is visible. This ensures that when we remount
// the component, we don't have stale // indices in the listViewState and can properly determine
// whether to scroll to the focused row.
mutator(onModuleClick, actionMessage => {
    if (actionMessage.module !== Module.Mail) {
        const listViewState = getListViewState();
        listViewState.startIndexVLV = -1;
        listViewState.endIndexVLV = -1;
    }
});
